// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ExternalImportSourceProjectCounts,
  ExternalImportSourceProjectCountsFromJSON,
  ExternalImportSourceProjectCountsToJSON,
} from "./";

/**
 *
 * @export
 * @interface ExternalImportSourceProject
 */
export interface ExternalImportSourceProject {
  /**
   * Source-system project key
   * @type {string}
   * @memberof ExternalImportSourceProject
   */
  key: string;
  /**
   * Source-system project name
   * @type {string}
   * @memberof ExternalImportSourceProject
   */
  name: string;
  /**
   *
   * @type {ExternalImportSourceProjectCounts}
   * @memberof ExternalImportSourceProject
   */
  counts?: ExternalImportSourceProjectCounts;
  /**
   * True if a completed import already exists for this source project in the destination TestCollab project
   * @type {boolean}
   * @memberof ExternalImportSourceProject
   */
  alreadyImported?: boolean;
  /**
   * ID of the most recent existing import in the destination TestCollab project (if any)
   * @type {number}
   * @memberof ExternalImportSourceProject
   */
  lastImportId?: number;
  /**
   * Timestamp of the most recent completed import in the destination TestCollab project
   * @type {string}
   * @memberof ExternalImportSourceProject
   */
  lastImportedAt?: string;
}

export function ExternalImportSourceProjectFromJSON(
  json: any
): ExternalImportSourceProject {
  return {
    key: json["key"],
    name: json["name"],
    counts: !exists(json, "counts")
      ? undefined
      : ExternalImportSourceProjectCountsFromJSON(json["counts"]),
    alreadyImported: !exists(json, "already_imported")
      ? undefined
      : json["already_imported"],
    lastImportId: !exists(json, "last_import_id")
      ? undefined
      : json["last_import_id"],
    lastImportedAt: !exists(json, "last_imported_at")
      ? undefined
      : json["last_imported_at"],
  };
}

export function ExternalImportSourceProjectToJSON(
  value?: ExternalImportSourceProject
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    key: value.key,
    name: value.name,
    counts: ExternalImportSourceProjectCountsToJSON(value.counts),
    already_imported: value.alreadyImported,
    last_import_id: value.lastImportId,
    last_imported_at: value.lastImportedAt,
  };
}
